import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Function to get all medical claims data from backend API
export const getAllMedicalClaims = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}api/MedicalClaims`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Function to upload document for Smart Claims Assistant
export const uploadSmartClaimDocument = async (file, user_id, claim_type, description, amount) => {
  const formData = new FormData();
  formData.append('receiptImage', file); // Match backend parameter name
  formData.append('user_id', user_id);
  formData.append('claim_type', claim_type);
  formData.append('description', description);
  formData.append('amount', amount);

  try {
    const response = await axios.post(`${API_BASE_URL}api/MedicalClaims/Create`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};